<kt-base-modal [title]="'Breaks'">
    <div modal-body>
        <div class="shift-breaks-min-height">
            <kt-loader [showLoader]="loading()">
                <ng-container *ngFor="let break of breaks">
                    <div class="mb-2">
                        <div class="form-group w-100 ">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text px-3 py-2">
                                        <svg-icon class="svg_icon30x30 d-inline "
                                            *ngIf="break?.timesheet_log_name === breakTypeEnum.MealBreak" src="assets/media/iq-svg/without_circle/icon_set_2/on_break.svg"></svg-icon>
                                        <svg-icon class="svg_icon30x30 d-inline "
                                            *ngIf="break?.timesheet_log_name === breakTypeEnum.RestBreak" src="assets/media/iq-svg/without_circle/icon_set_5/meal_break.svg"></svg-icon>
                                    </span>
                                </div>
                                <div style="height: 80px;" rows="3" class="form-control" disabled>
                                    <div *ngIf="break?.timesheet_log_display_type">
                                        <h5> {{break?.timesheet_log_display_type}} </h5>
                                    </div>
                                    <div *ngIf="break?.timesheet_log_total_actual_time"> Duration:-
                                        {{break?.timesheet_log_total_actual_time + ' Min'}}</div>
                                    {{(break.timesheet_log_start_date | TimezoneDateTime) + ' - ' + (
                                    break.timesheet_log_end_date ? (break.timesheet_log_end_date | TimezoneDateTime) :
                                    '') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!loading() && ! (breaks && breaks.length)">
                    <kt-no-record-found [noRecordFound]="noRecordFound"></kt-no-record-found>
                </ng-container>

            </kt-loader>

        </div>
        <div class="d-flex modal-footer justify-content-start">
            <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
            </kt-button>
        </div>
    </div>
</kt-base-modal>